import Madison1 from '../../../Media/Ruko Paramount/Madison Grande/Madison Grande (1).webp'
import Madison2 from '../../../Media/Ruko Paramount/Madison Grande/Madison Grande (2).webp'
import Madison3 from '../../../Media/Ruko Paramount/Madison Grande/Madison Grande (3).webp'

const Madisonimages =[
Madison1,Madison2,Madison3
]

export default Madisonimages;
